import React from 'react';
import './style.scss';
import { getTicketStatusLabel } from './Constants';


const TicketCreationSuccess = (props: any) => {
    const ticket_data = props.ticket_data;
    if(!ticket_data) return null;
    const statusLabel = getTicketStatusLabel(ticket_data.status);
    return (
        <div className="ticket-creation-success">
            <div className="ticket-creation-success-title">Your ticket is raised</div>
            <div className="ticket-creation-success-details">
                <div className="ticket-creation-success-main-detail">
                    <div className="ticket-creation-success-number">Ticket #{ticket_data.ticketNumber}</div>
                    {
                        !props.hideStatus && <div className="ticket-creation-success-detail">
                            <div className={`ticket-creation-success-detail-dot ticket-creation-success-detail-dot-${ticket_data?.status?.toLowerCase()}`} />
                            {statusLabel}
                        </div>
                    }
                </div>
                <div className="ticket-creation-success-date">{new Date(ticket_data.createdAt).toLocaleString('en-GB', { day: '2-digit', month: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit' })}</div>
            </div>
        </div>
    );
};

export default TicketCreationSuccess;
